export default __webpack_public_path__ + "static/media/features-small.d064f21b.svg";